import { get, keys, reduce, isNil, isEmpty, includes } from 'lodash';
import { Validations } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { AboutYouForm, AboutYouHealthForm } from '@models/DPI/AboutYou.model';


export const validate = (values: AboutYouForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'duties':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'Please enter your exact duties' }
        } else {
          if (!Validations.isDutyOfOccupationValid(value)) {
            error = { isValid: false, message: "Please exclude special characters other than hyphen (-) or apostrophe (')" }
          }
        }
      }
      break;
    case 'nature':
      if (isNil(value)) {
        error = { isValid: false };
      }
      break;
    case 'otherBusiness':
      if (values['nature'] === '12') {
        if (isNil(value)) {
          error = { isValid: false };
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: 'Please specify your nature of business of employer' }
          } else {
            if (!Validations.isDutyOfOccupationValid(value)) {
              error = { isValid: false, message: "Please exclude special characters other than hyphen (-) or apostrophe (')" }
            }
          }
        }
      }
      break;
    case 'fund':
    case 'wealth':
      if (isNil(value) || get(value, 'length', 0) === 0) {
        error = { isValid: false };
      }
      break;
    case 'income':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: "This field cannot be empty" };
        }
      }
      break;
    case 'otherFund':
      const fund = values['fund'];
      if (!isNil(fund) && includes(fund, 'other')) {
        if (isNil(value)) {
          error = { isValid: false };
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: 'Please specify your source of funds' };
          }
          if (!Validations.isDutyOfOccupationValid(value)) {
            error = { isValid: false, message: "Please don’t include special characters other than hyphens (-) or apostrophes (')" };
          }
        }
      }
      break;
    case 'otherWealth':
      const wealth = values['wealth'];
      if (!isNil(wealth) && includes(wealth, 'other')) {
        if (isNil(value)) {
          error = { isValid: false };
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: 'Please specify your source of wealth' };
          }
          if (!Validations.isDutyOfOccupationValid(value)) {
            error = { isValid: false, message: "Please don’t include special characters other than hyphens (-) or apostrophes (')" };
          }
        }

      }
      break;
  }
  return error;
}

export const validateHealthForm = (values: AboutYouHealthForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateFieldFormHealth(values, field) };
  }, {});
  return errors;
}

export const validateFieldFormHealth = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'q1':
    case 'q2':
    case 'q3':
    case 'q4':
    case 'q5':
    case 'q6':
    case 'q7':
    case 'q8':
    case 'q9':
    case 'q10':
    case 'q11':
      if (isNil(value)) {
        error = { isValid: false };
      }
      break;
    case 'q12':
      if (values['gender'] === 'F') {
        if (isNil(value)) {
          error = { isValid: false };
        }
      }
      break;
    case 'lessThan40Sticks':
      if (values['isSmoker'] === true) {
        if (isNil(value)) {
          error = { isValid: false };
        }
      }
      break;
    case 'height':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: `This field cannot be empty` };
        } else {
          const minHeight = 75, maxHeight = 250;
          const isOutOfRangeHeight = Validations.isInRange(Number(value), minHeight, maxHeight);
          if (isOutOfRangeHeight !== 0) {
            error = { isValid: false, message: `Please enter a valid height from ${minHeight}cm to ${maxHeight}cm` };
          }
        }
      }
      break;
    case 'weight':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: `This field cannot be empty` };
        } else {
          const minWeight = 25, maxWeight = 200;
          const isOutOfRangeWeight = Validations.isInRange(Number(value), minWeight, maxWeight);
          if (isOutOfRangeWeight !== 0) {
            error = { isValid: false, message: `Please enter a valid weight from ${minWeight}kg to ${maxWeight}kg` };
          }
        }
      }
      break;
    default:
      break;
  }
  return error;
}